const hasHr = (data) => data.hr;

export default hasHr;
